// Auth route — "Forgot password" (US-005).

import { createRoute } from '@tanstack/react-router';

import { ForgotPasswordPage } from '@/features/auth/ForgotPasswordPage';

import { Route as RootRoute } from '../__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/auth/forgot',
  component: ForgotPasswordPage,
});
